/**
 * Component option inheritAttrs does not disable the inheritance of class or style.
 * @see https://vuejs.org/v2/api/#inheritAttrss
 */
export var StaticClass = {
    inserted: function (el, binding, node, odNode) {
        var _a;
        var parentData = node.context != null ? node.context.$vnode.data : null;
        if (parentData != null && parentData.staticClass != null) {
            (_a = el.classList).remove.apply(_a, parentData.staticClass.split(' '));
        }
    }
};
export var StaticStyle = {
    inserted: function (el, binding, node, odNode) {
        var parentData = node.context != null ? node.context.$vnode.data : null;
        if (parentData != null && parentData.staticStyle != null) {
            for (var styleName in parentData.staticStyle) {
                var style = parentData.staticStyle[styleName];
                if (el.style[styleName] == style) {
                    el.style[styleName] = null;
                }
            }
        }
    }
};
